<template>
    <div class="superviseLock">

        <el-dropdown split-button type="primary" size="mini" style="width: 120px;">
            监管锁
            <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                    <el-button @click="setEquipmentNoEvent" type="primary" size="mini">设置设备号</el-button>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                    <el-button @click="searchSheEvent" type="warning" size="mini">查询设备信息</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="setSheEvent" type="primary" size="mini">设置设备信息</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="commandEvent" type="primary" size="mini">设备控制</el-button>
                </el-dropdown-item> -->
                <el-dropdown-item>
                    <el-button @click="lostEvent" type="danger" size="mini">丢失模式</el-button>
                </el-dropdown-item>
                <!-- <el-dropdown-item>
                    <el-button @click="setAppEvent" type="warning" size="mini">配置默认APP限制</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="setFunctionEvent" type="primary" size="mini">配置默认功能限制</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="wallpaperEvent" type="primary" size="mini">配置默认壁纸</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="removeLockEvent" type="danger" size="mini">移除激活锁</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="lookPasswordEvent" type="primary" size="mini">查看激活锁密码</el-button>
                </el-dropdown-item>
                <el-dropdown-item>
                    <el-button @click="unbindAbmEvent" type="danger" size="mini">ABM解绑</el-button>
                </el-dropdown-item>  -->
            </el-dropdown-menu>
        </el-dropdown>
        <el-dialog title="设置设备信息" :visible.sync="showSetSheDialog" width="50%">
            <el-form :model="setSheForm" label-width="100px">
                <el-form-item label="租赁人姓名">
                    <el-input v-model="setSheForm.name" placeholder="请输入租赁人姓名"></el-input>
                </el-form-item>
                <el-form-item label="手机号">
                    <el-input v-model="setSheForm.phone" placeholder="请输入手机号"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="showSetSheDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitSetShe">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="查询设备信息" :visible.sync="showGetSheDialog" width="50%">
            <div class="desc_wrap" v-if="sheInfoForm">
                <div>
                    <div class="desc_item">租赁⼈姓名: {{ sheInfoForm.hirer_name }}</div>
                    <div class="desc_item">租赁⼈手机号: {{ sheInfoForm.hirer_phone_number }}</div>
                    <div class="desc_item">产品名称: {{ sheInfoForm.product_name }}</div>
                    <div class="desc_item">设备最后活动时间：{{ sheInfoForm.last_active_time }}</div>
                    <div class="desc_item">设备ABM在库状态:
                        <el-tag size="small" v-if="sheInfoForm.abm_status == 0">未在库</el-tag>
                        <el-tag size="small" v-else>在库</el-tag>
                    </div>
                    <div class="desc_item">设备监管状态：
                        <el-tag size="small" v-if="sheInfoForm.supervise_status == 0">未监管</el-tag>
                        <el-tag size="small" v-else-if="sheInfoForm.supervise_status == 1">不完全监管</el-tag>
                        <el-tag size="small" v-else>完全监管</el-tag>
                    </div>
                    <div class="desc_item">设备激活锁状态：
                        <el-tag size="small" v-if="sheInfoForm.activation_lock_status == 0">未开启</el-tag>
                        <el-tag size="small" v-else>已开启</el-tag>
                    </div>
                    <div class="desc_item">设备丢失模式状态：
                        <el-tag size="small" v-if="sheInfoForm.lost_mode_status == 0">未开启</el-tag>
                        <el-tag size="small" v-else>已开启</el-tag>
                    </div>
                </div>
                <div>
                    <template v-if="sheInfoForm.system_restriction">
                        <div class="desc_item">允许主机配对:
                            <el-tag size="small" v-if="sheInfoForm.system_restriction.allowHostPairing">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">允许"信任企业开发者":
                            <el-tag size="small" v-if="sheInfoForm.system_restriction.allowEnterpriseAppTrust">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">允许"抹除所有内容和设置":
                            <el-tag size="small"
                                v-if="sheInfoForm.system_restriction.allowEraseContentAndSettings">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">允许设备锁定时使⽤USB设备:
                            <el-tag size="small" v-if="sheInfoForm.system_restriction.allowUSBRestrictedMode">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">强制使⽤"⾃动设置"⽇期和时间:
                            <el-tag size="small" v-if="sheInfoForm.system_restriction.forceAutomaticDateAndTime">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">允许⽤户设置壁纸，逾期时可关闭，阻⽌⽤户改回壁纸:
                            <el-tag size="small"
                                v-if="sheInfoForm.system_restriction.allowWallpaperModification">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                        <div class="desc_item">允许添加VPN:
                            <el-tag size="small" v-if="sheInfoForm.system_restriction.allowVPNCreation">开启</el-tag>
                            <el-tag size="small" v-else>关闭</el-tag>
                        </div>
                    </template>
                </div>
            </div>
        </el-dialog>
        <el-dialog title="配置默认APP限制" :visible.sync="showSetAppDialog" width="50%">
            <el-form :model="setSheForm" label-width="100px">
                <el-form-item label="状态">
                    <el-radio v-model="setSheForm.status" :label="0">关闭</el-radio>
                    <el-radio v-model="setSheForm.status" :label="1">开启</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="showSetAppDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitSetApp">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="配置默认壁纸" :visible.sync="showWallpaperDialog" width="50%">
            <el-form :model="setSheForm" label-width="150px">
                <el-form-item label="系统内置的壁纸样式">
                    <el-radio v-model="setSheForm.style" :label="0">即将预期</el-radio>
                    <el-radio v-model="setSheForm.style" :label="1">今日到期</el-radio>
                    <el-radio v-model="setSheForm.style" :label="2">已逾期</el-radio>
                </el-form-item>
                <el-form-item label="是否允许租赁⼈修改壁纸">
                    <el-radio v-model="setSheForm.allow" :label="0">否</el-radio>
                    <el-radio v-model="setSheForm.allow" :label="1">是</el-radio>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="showWallpaperDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitWallpaper">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="查看激活锁密码" :visible.sync="showLookPasswordDialog" width="50%">
            <el-form :model="setSheForm" label-width="150px">
                <el-form-item label="激活锁密码">
                    <el-input v-model="setSheForm.password" show-password></el-input>
                </el-form-item>
            </el-form>
        </el-dialog>
        <el-dialog title="丢失模式" :visible.sync="showLostDialog" width="50%">
            <el-form :model="setLostForm" label-width="100px">
                <el-form-item label="状态">
                    <el-radio v-model="setLostForm.status" :label="0">关闭</el-radio>
                    <el-radio v-model="setLostForm.status" :label="1">开启</el-radio>
                </el-form-item>
                <el-form-item label="锁屏主信息">
                    <el-input v-model="setLostForm.message" placeholder="开启丢失模式时必填"></el-input>
                </el-form-item>
                <el-form-item label="大陆手机号">
                    <el-input v-model="setLostForm.phone_number"></el-input>
                </el-form-item>
                <el-form-item label="脚注">
                    <el-input v-model="setLostForm.footnote"></el-input>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="showLostDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitLost">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="配置默认功能限制" :visible.sync="showFunctionDialog" width="50%">
            <el-form :model="setFunctionForm" label-width="300px">
                <el-form-item label="允许主机配对，监管时请保持关闭">
                    <el-switch v-model="setFunctionForm.allowHostPairing">
                    </el-switch>
                </el-form-item>
                <el-form-item label="允许'信任企业开发者'，监管时请保持关闭">
                    <el-switch v-model="setFunctionForm.allowEnterpriseAppTrust">
                    </el-switch>
                </el-form-item>
                <el-form-item label="允许'抹除所有内容和设置'，监管时请保持关闭">
                    <el-switch v-model="setFunctionForm.allowEraseContentAndSettings">
                    </el-switch>
                </el-form-item>
                <el-form-item label="允许设备锁定时使⽤USB设备,监管时请保持关闭">
                    <el-switch v-model="setFunctionForm.allowUSBRestrictedMode">
                    </el-switch>
                </el-form-item>
                <el-form-item label="强制使⽤'⾃动设置'⽇期和时间，监管时请保持打开">
                    <el-switch v-model="setFunctionForm.forceAutomaticDateAndTime">
                    </el-switch>
                </el-form-item>
                <el-form-item label="允许⽤户设置壁纸，逾期时可关闭，阻⽌⽤户改回壁纸">
                    <el-switch v-model="setFunctionForm.allowWallpaperModification">
                    </el-switch>
                </el-form-item>
                <el-form-item label="允许添加VPN,监管时建议保持关闭">
                    <el-switch v-model="setFunctionForm.allowVPNCreation">
                    </el-switch>
                </el-form-item>
                <el-form-item label="强制开启WiFi,开启后⽆法关闭WiFi">
                    <el-switch v-model="setFunctionForm.forceWiFiPowerOn">
                    </el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="showFunctionDialog = false">取 消</el-button>
                <el-button type="primary" @click="submitFunction">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
import OrderApi from "@/api/order.js";
export default {
    name: "superviseLock",
    props: {
        item: {
            type: Object,
            default: {}
        }
    },
    data() {
        return {
            showSetSheDialog: false,
            setSheForm: {
                name: '',
                phone: '',
                status: null,
                style: null,
                allow: null,
                password: null
            },
            setLostForm: {
                status: null,
                message: '',
                phone_number: '',
                footnote: ''
            },
            showLostDialog: false,
            sheInfoForm: {},
            showGetSheDialog: false,
            lostDialogTitle: '',
            apiType: null,
            showWallpaperDialog: false,
            showLookPasswordDialog: false,
            showSetAppDialog: false,
            showFunctionDialog: false,
            setFunctionForm: {
                allowHostPairing: false,
                allowEnterpriseAppTrust: false,
                allowEraseContentAndSettings: false,
                allowUSBRestrictedMode: false,
                forceAutomaticDateAndTime: false,
                allowWallpaperModification: false,
                allowVPNCreation: false,
                forceWiFiPowerOn: false,
            }
        }
    },
    methods: {
        setFunctionEvent() {
            this.showFunctionDialog = true;
            this.setFunctionForm = {
                allowHostPairing: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowHostPairing || false,
                allowEnterpriseAppTrust: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowEnterpriseAppTrust || false,
                allowEraseContentAndSettings: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowEraseContentAndSettings || false,
                allowUSBRestrictedMode: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowUSBRestrictedMode || false,
                forceAutomaticDateAndTime: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.forceAutomaticDateAndTime || false,
                allowWallpaperModification: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowWallpaperModification || false,
                allowVPNCreation: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.allowVPNCreation || false,
                forceWiFiPowerOn: this.sheInfoForm.system_restriction && this.sheInfoForm.system_restriction.forceWiFiPowerOn || false
            }
        },
        submitFunction() {
            let params = {};
            params.order_id = this.item.order_id
            params.allowHostPairing = this.setFunctionForm.allowHostPairing
            params.allowEnterpriseAppTrust = this.setFunctionForm.allowEnterpriseAppTrust
            params.allowEraseContentAndSettings = this.setFunctionForm.allowEraseContentAndSettings
            params.allowUSBRestrictedMode = this.setFunctionForm.allowUSBRestrictedMode
            params.forceAutomaticDateAndTime = this.setFunctionForm.forceAutomaticDateAndTime
            params.allowWallpaperModification = this.setFunctionForm.allowWallpaperModification
            params.forceWiFiPowerOn = this.setFunctionForm.forceWiFiPowerOn
            params.allowVPNCreation = this.setFunctionForm.allowVPNCreation
            OrderApi.systemConfig(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
                this.showFunctionDialog = false
            }).catch(err => {
                console.log(err);
            })
        },
        submitLost() {
            let params = {};
            if (this.setLostForm.status == 1 && this.setLostForm.message == '') {
                this.$message.warning("丢失模式开启时，锁屏主信息必填");
                return;
            }
            params.order_id = this.item.order_id
            params.status = this.setLostForm.status;
            params.message = this.setLostForm.message;
            params.phone_number = this.setLostForm.phone_number;
            params.footnote = this.setLostForm.footnote
            OrderApi.lost(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
                this.showLostDialog = false
            }).catch(err => {
                console.log(err);
            })
        },
        // 丢失模式
        lostEvent() {
            this.showLostDialog = true;
            this.setLostForm = {
                status: null,
                message: '',
                phone_number: '',
                footnote: ''
            }
        },
        // 配置app限制
        setAppEvent() {
            this.showSetAppDialog = true;
            this.setSheForm = {
                status: null
            }
        },
        submitSetApp() {
            let params = {};
            params.order_id = this.item.order_id
            params.status = this.setSheForm.status;
            OrderApi.appConfig(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
                this.showSetAppDialog = false
            }).catch(err => {
                console.log(err);
            })
        },

        // ABM解绑
        unbindAbmEvent() {
            this.$confirm("确认解绑ABM？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params = {};
                params.order_id = this.item.order_id
                OrderApi.unbindAbm(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            })
        },
        // 查看激活锁密码
        lookPasswordEvent() {
            let params = {};
            params.order_id = this.item.order_id
            OrderApi.lookPassword(params).then(res => {
                if (res.code == 1) {
                    this.showLookPasswordDialog = true;
                    this.setSheForm.password = res.data.password
                } else {
                    this.$message.error(res.msg);
                }
            }).catch(err => {
                console.log(err);
            })
        },
        // 移除激活锁
        removeLockEvent() {
            this.$confirm("确认移除激活锁？", '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(() => {
                let params = {};
                params.order_id = this.item.order_id
                OrderApi.removeLock(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            })
        },
        // 配置默认壁纸
        wallpaperEvent() {
            this.setSheForm = {
                style: null,
                allow: null
            }
            this.showWallpaperDialog = true
        },
        submitWallpaper() {
            let params = {};
            params.order_id = this.item.order_id
            params.style = this.setSheForm.style;
            params.allow = this.setSheForm.allow;
            OrderApi.wallpaper(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
                this.showWallpaperDialog = false
            }).catch(err => {
                console.log(err);
            })
        },

        // 设置控制
        commandEvent() {
            this.$prompt("请输入操作命令", '', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(val => {
                let params = {};
                params.order_id = this.item.order_id
                params.command = val.value;
                OrderApi.command(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            }).catch(() => {
                return;
            })
        },
        submitSetShe() {
            let params = {};
            params.order_id = this.item.order_id
            params.name = this.setSheForm.name;
            params.phone = this.setSheForm.phone;
            OrderApi.setShe(params).then(res => {
                if (res.code == 1) {
                    this.$message.success(res.msg);
                } else {
                    this.$message.error(res.msg);
                }
                this.showSetSheDialog = false
            }).catch(err => {
                console.log(err);
            })
        },
        // 设置设备信息
        setSheEvent() {
            this.showSetSheDialog = true
            this.setSheForm = {
                name: this.sheInfoForm.hirer_name || '',
                phone: this.sheInfoForm.hirer_phone_number || ''
            }
        },
        // 查询设备信息
        searchSheEvent() {
            this.showGetSheDialog = true;
            this.getSheEvent()
        },
        getSheEvent() {
            let params = {};
            params.order_id = this.item.order_id
            OrderApi.getShe(params).then(res => {
                this.sheInfoForm = res.data;
            }).catch(err => {
                console.log(err);
            })
        },
        // 设置设备号
        setEquipmentNoEvent() {
            this.$prompt("请输入设备号", '设备号', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning',
            }).then(val => {
                let params = {};
                params.order_id = this.item.order_id
                params.number = val.value;
                OrderApi.setEquipmentNo(params).then(res => {
                    if (res.code == 1) {
                        this.$message.success(res.msg);
                    } else {
                        this.$message.error(res.msg);
                    }
                }).catch(err => {
                    console.log(err);
                })
            }).catch(() => {
                return;
            })

        }
    }
}
</script>
<style lang="scss">
.desc_wrap {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .desc_item {
        line-height: 30px;
        margin: 10px;
    }
}
</style>
<style lang="scss" scoped>
.el-dropdown-menu__item+.el-dropdown-menu__item {
    margin-top: 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/order/order/dialog/superviseLock.vue